export function serviceProject(value?: string): string[] {
    if (!value) return [];

    return value.split(',').filter(element => element !== '0');
}
